










































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { trim } from '@/utils/validators';
import { resetPassword } from '@/api/system-management/index';

export interface IForm {
  newPassword: string; // 密码
}

@Component
export default class AddEditModal extends Vue {
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop()
  userId!: string;

  // 校验字段方法
  validatorsTrim = trim;
  form: any = null;

  confirmLoading: boolean = false;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };

  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  mounted() {
    this.init();
  }

  init() {
    this.form = this.$form.createForm(this);
  }

  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.resetPassword(values);
      }
    });
  }
  async resetPassword(values: IForm) {
    if (this.confirmLoading) return false;
    this.confirmLoading = true;
    try {
      const { newPassword } = values;
      const result = await resetPassword({
        userId: this.userId,
        newPassword
      });
      this.$message.success(`重置成功`);
      this.form.resetFields();
      this.$emit('create');
    } catch (e) {
      this.$message.error((e && e.msg) || `重置失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
}
